export default interface SerStationGroup {
    id: number;
    name: string;
}

export const serStationGroupDefaultProps: SerStationGroup = {
    id: 0,   
    name: "",
}